// @flow

import React from 'react';

type Props = {
  base: string,
  icon: string,
  header: string,
  subheader: string,
  children: any,
};

const Hero = (props: Props) => {
  const { children, base, icon, header, subheader } = props;

  return (
    <div className="hero-container">
      <div className="hero">
        <div className="hero-contain">
          <div className="column medium-8 hero-text">
            <h1 className="hero-header">{header}</h1>
            <h4 className="hero-subheader">{subheader}</h4>
            {children}
          </div>
          {icon && (
            <img
              className="column medium-3 hero-image"
              alt={`${base} hero`}
              width={178}
              height={160}
              src={icon} />
          )}
        </div>
      </div>
    </div>
  );
};

Hero.defaultProps = {
  base: '',
  icon: '',
  header: '',
  subheader: '',
  children: null,
};

export default Hero;
